var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_2299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4501 0.5H1.54996C0.693972 0.5 3.05176e-05 1.24352 3.05176e-05 2.16066V13.8393C3.05176e-05 14.2798 0.163391 14.7024 0.454255 15.014C0.744446 15.325 1.1389 15.5 1.54996 15.5H14.4501C14.8612 15.5 15.2556 15.325 15.5458 15.014C15.8367 14.7024 16 14.2798 16 13.8393V2.16066C16 1.72023 15.8367 1.2976 15.5458 0.985966C15.2556 0.675043 14.8612 0.5 14.4501 0.5ZM10.0002 1.57153V14.4285H5.99989V1.57153H10.0002ZM1.00018 13.8394V2.16077C1.00018 1.83561 1.24654 1.57164 1.55003 1.57164H4.99985V14.4286H1.55003C1.40393 14.4286 1.26448 14.3667 1.16088 14.2564C1.05795 14.1454 1.00018 13.996 1.00018 13.8394ZM15.0001 13.8394C15.0001 13.996 14.9423 14.1454 14.8394 14.2564C14.7358 14.3667 14.5963 14.4286 14.4502 14.4286H11.0004V1.5716H14.4502C14.5963 1.5716 14.7358 1.63351 14.8394 1.74379C14.9423 1.85479 15.0001 2.0042 15.0001 2.16074V13.8394Z",
    fill: "#4D1DF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_2299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/grid_icon.25274b66321ad0cce5bd2908f3658d4c.svg";
export { ForwardRef as ReactComponent };